<span class="text-xs-right truncated body-2 black--text">{{content}}</span>
